import {CanvasComponent} from "../canvas/canvas.component";
import {CanvasRenderer, StateInfoItem} from "./stateinfoitemrendererfactory";


export class PointText implements StateInfoItem {
    type: string = "PointText";
    color: string;
    text: string;
    isvisible: boolean;

    // TODO: use new typescript feature "Partial" for initializing with Objects
    constructor(position: any, text: string, color?: string, isVisible?: boolean) {
        this.position = position;
        this.text = text;
        this.color = color || 'red';
        this.isvisible = isVisible;
    }

    position: {
        x: number,
        y: number,
    }
}


// TODO: refactor

export class PointTextCanvasRenderer implements CanvasRenderer {

    renderText(paperjsScope: any, position: any, text: string, color: string, isVisible: boolean) {
        let xPosition;
        let yPosition;
        const viewBounds = paperjsScope.project.activeLayer.bounds;
        xPosition = viewBounds.x + (viewBounds.width / 2);
        yPosition = viewBounds.y + 3;


        let rectangleLayer = new paperjsScope.Layer();
        rectangleLayer.name = 'rectangle';
        rectangleLayer.activate();
        let backgroundRectangle = new paperjsScope.Rectangle(viewBounds.x + 1, viewBounds.y + 1, viewBounds.width - 2, 15);
        let backgroundRectanglePath = new paperjsScope.Path.Rectangle(backgroundRectangle);
        backgroundRectanglePath.fillColor = 'rgba(180, 0, 0, 0.7)';

        let layer = new paperjsScope.Layer();
        layer.name = 'text';
        layer.activate();

        yPosition = yPosition + 9; // y position 0 should be on top of text (and some margin)
        const pointText = new paperjsScope.PointText(new paperjsScope.Point(xPosition, yPosition));
        pointText.justification = 'center';
        pointText.fillColor = '#ffffff';
        pointText.fontSize= '12px';
        pointText.content = text;
        layer.scale(viewBounds.width / layer.bounds.width);
    }

    renderToCanvas(element: PointText, canvas: CanvasComponent) {
        let scope = canvas.activateAndGetPaperScope();
        this.renderText(scope, element.position, element.text, element.color, element.isvisible);
    }

}
